import Loadable from 'components/core/Loadable';
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Auth
const WarrantyVtechPage = Loadable(lazy(() => import('pages/WarrantyVtech/index')));


const WarrantyVtech: RouteObject = {
  path: 'bao-hanh-san-pham-vtech/:warrantyId',
  element: <WarrantyVtechPage />,
};

export default WarrantyVtech;
